export default "__VITE_ASSET__DYNyGcHQ__"